
export class AccessTokenCreateDto {
  public publicToken: string;
  public verificationStatus: string | null;
  public holdingId: number;
}
